var _desc, _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagGb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32",
    id: "Gb-Nir-Northern-Ireland--Streamline-Flagpack",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    GB NIR\t Northern Ireland Streamline Icon: https://streamlinehq.com\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2e42a5",
    fillRule: "evenodd",
    d: "M0 4v24h32V4H0Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 32,
    height: 24,
    x: 0,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    fillRule: "evenodd",
    d: "M0 4v24h32V4H0Z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m-3.563 26.285 7.042 2.978 28.68-22.025 3.715-4.426-7.53-.995-11.698 9.491-9.416 6.395-10.793 8.582Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f50100",
    d: "M-2.599 28.372.99 30.1 34.54 2.401h-5.038L-2.6 28.371Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m35.563 26.285-7.042 2.978L-.159 7.238l-3.715-4.426 7.53-.995 11.698 9.491 9.416 6.395 10.793 8.582Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f50100",
    d: "m35.323 27.782-3.588 1.729-14.287-11.86-4.235-1.325L-4.232 2.827H.806L18.24 16.006l4.631 1.589 12.452 10.188Z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.778 2h-7.556v10H-1.972v8h14.194v10h7.556V20h14.25v-8h-14.25V2Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#f50100",
    fillRule: "evenodd",
    d: "M19.778 2h-7.556v10H-1.972v8h14.194v10h7.556V20h14.25v-8h-14.25V2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M12.222 2V0h-2v2h2Zm7.556 0h2V0h-2v2Zm-7.556 10v2h2v-2h-2Zm-14.194 0v-2h-2v2h2Zm0 8h-2v2h2v-2Zm14.194 0h2v-2h-2v2Zm0 10h-2v2h2v-2Zm7.556 0v2h2v-2h-2Zm0-10v-2h-2v2h2Zm14.25 0v2h2v-2h-2Zm0-8h2v-2h-2v2Zm-14.25 0h-2v2h2v-2Zm-7.556-8h7.556V0h-7.556v4Zm2 8V2h-4v10h4Zm-16.194 2h14.194v-4H-1.972v4Zm2 6v-8h-4v8h4Zm12.194-2H-1.972v4h14.194v-4Zm2 12V20h-4v10h4Zm5.556-2h-7.556v4h7.556v-4Zm-2-8v10h4V20h-4Zm16.25-2h-14.25v4h14.25v-4Zm-2-6v8h4v-8h-4Zm-12.25 2h14.25v-4h-14.25v4Zm-2-12v10h4V2h-4Z",
    mask: "url(#b)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagGb);
export default __webpack_public_path__ + "static/media/Flag_GB.b23e66cbb528967a3352ee7b6a7387ab.svg";
export { ForwardRef as ReactComponent };